// extracted by mini-css-extract-plugin
export default {"createInput":"BoardEditStep_createInput__kqCcS","buttons":"BoardEditStep_buttons__DmVEU"};